export const combineDispatchers = ( ...args ) => dispatch => {
  let result = { dispatch };
  for ( let item of args ) {
    result = {...result, ...item( dispatch )};
  }
  return result;
};